import { Components } from '@mui/material/styles/components';
import theme from '../../provider/controllerBaseTheme';

export const CheckboxComponent: Components = {
  MuiCheckbox: {
    styleOverrides: {
      root: {
        // padding: theme.spacing(1),
        color: theme.palette.grey[600],
        '&.Mui-checked': {
          color: theme.palette.primary,
        },
      },
    },
  },
};
